<template>
  <div>
    <section id="container" class="gnb_pdt">
      <div class="title_wrap">
        <h1 class="f_l">무인 보관함 목록</h1>
      </div>
      <!--  검색 창  -->
      <div class="contents_wrap mg0">
        <div class="content_list">
          <div class="button_wrap_area">
            <ul>
              <li>
                <button class="large_btn orange" @click="commonOnChangeEvent">검색</button>
              </li>
              <li>
                <button class="large_btn" @click="cleanFilter">초기화</button>
              </li>
            </ul>
          </div>
          <div id="filter_section" class="filter_wrap">
            <ul class="filter_list">
              <li class="col2">
                <dd>
                  <label>사업장/거점</label>
                  <ul>
                    <li>
                      <kendo-multicolumncombobox
                          class='w100'
                          :data-source="dataSourceArray"
                          :data-text-field="'facilityAndArea'"
                          :data-value-field="'cdId'"
                          :placeholder="'사업장 / 거점 선택'"
                          :value="lastRouteParams.area"
                          ref="areaRef"
                          @change="commonOnChangeEvent"
                      >
                        <kendo-multicolumncombobox-column
                            :title="'사업장'"
                            :field="'facility'"
                        ></kendo-multicolumncombobox-column>
                        <kendo-multicolumncombobox-column
                            :title="'거점'"
                            :field="'area'"
                        ></kendo-multicolumncombobox-column>
                      </kendo-multicolumncombobox>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>무인 보관함 명</label>
                  <ul>
                    <li>
                      <kendo-maskedtextbox
                          ref="lockerNmRef"
                          :value="lastRouteParams.lockerNm"
                          :placeholder="'무인 보관함 명 입력'"
                          class='w100'
                          id="lockerNm"
                          @change="commonOnChangeEvent"
                      >
                      </kendo-maskedtextbox>
                    </li>
                  </ul>
                </dd>
              </li>
              <li class="col2">
                <dd>
                  <label>활성화 여부</label>
                  <ul>
                    <li>
                      <kendo-buttongroup
                          ref="useYnRef"
                          :index="0"
                          :value="lastRouteParams.useYn"
                          :style="{width: '100%', border: '0'}"
                          @select="commonOnChangeEvent"
                      >
                        <kendo-buttongroup-button
                            v-for="item in ['전체', '사용', '미사용']"
                            :style="{width: '33%'}"
                            v-bind:key="item"
                        >
                          {{ item }}
                        </kendo-buttongroup-button>
                      </kendo-buttongroup>
                    </li>
                  </ul>
                </dd>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--  리스트 영역 -->
      <kendo-grid
          ref="lockerGridRef"
          id="grid"
          class="basic_table mt10"
          :data-source="lockerDataSource"
          :columns="lockerListColumns"
          :navigatable="true"
          :filterable="false"
          :sortable="true"
          :scrollable="true"
          :pageable-always-visible="true"
          :pageable-page-sizes="[5, 10, 20, 50, 100, 500, 1000]"
          :reorderable="true"
          :column-menu="false"
          :resizable="true"
          :selectable="'multiple row'"
          :noRecords="{ template: '<div class=\'gridNoData\' style=\'text-align: center;\'>표시할 데이터가 없습니다.</div>' }">
      </kendo-grid>
    </section>
  </div>
</template>
<script>
import ApiConfig from "@/api/api.config";
import {LogisticsCodeDtlMixin, ZoneMixin} from "@/mixin/Mixin";
import EtnersParseUtil from "@/common/etners.parse.util";
import $ from "jquery"

export default {
  name: "LockerList",
  mixins: [LogisticsCodeDtlMixin, ZoneMixin],
  mounted() {
    const vm = this
    // 페이지 로딩 시 호출
    this.getlockerList()
    //엔터키 이벤트 자동 세팅
    const enterkeyEventTargetIdArray = [
      'lockerNm'
    ]
    for (const elementId of enterkeyEventTargetIdArray) {
      const element = document.getElementById(elementId)
      if (element !== undefined) {
        element.onkeyup = function (e) {
          const ENTER_KEY_CODE = 'Enter'
          const NUM_PAD_ENTER = 'NumpadEnter'
          const currentKeyCode = e.code

          if (currentKeyCode === ENTER_KEY_CODE || currentKeyCode === NUM_PAD_ENTER) {
            vm.commonOnChangeEvent(e)
          }
        }
      }
    }

    for (let i = 0; i < this.zone1DepthList.length; i++) {
      const zone1Depth = this.zone1DepthList[i].cdId
      const zone2DepthList = this.zone2DepthMap.get(zone1Depth) === undefined ? [{cdNm: '기타'}] : this.zone2DepthMap.get(zone1Depth)
      for (let j = 0; j < zone2DepthList.length; j++) {
        this.dataSourceArray.push({
          facilityAndArea: this.zone1DepthList[i].cdNm +' / '+zone2DepthList[j].cdNm,
          facility: this.zone1DepthList[i].cdNm,
          area: zone2DepthList[j].cdNm,
          cdId: zone2DepthList[j].cdId
        })
      }
    }
    vm.onETON()
  },
  methods: {
    // 무인보관함 리스트 API
    getlockerList() {
      const vm = this
      const lastRequestParameterPage = vm.lastRouteParams.page !== undefined ? vm.lastRouteParams.page : 1
      const lastRequestParameterPageSize = vm.lastRouteParams.pageSize !== undefined ? vm.lastRouteParams.pageSize : 10

      vm.lockerDataSource = new kendo.data.DataSource({
        name: 'lockerDataSource',
        page: lastRequestParameterPage,
        pageSize: lastRequestParameterPageSize,
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        transport: {
          read: {
            url: `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/locker/lockerList.json`,
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            cache: false
          },
          parameterMap(options, operation) {
            if (operation === 'read') {
              const paramToKendoFilters = vm.currentPageFilterOption()
              const params = {
                loginUserToken: vm.loginUserToken,
                skip: options.skip,
                take: options.take,
                sort: options.sort,
                page: options.page,
                pageSize: options.pageSize,
                area: paramToKendoFilters.area,
                storageType: paramToKendoFilters.storageType,
                useYn: paramToKendoFilters.useYn,
                lockerNm: paramToKendoFilters.lockerNm,
                requestType: 'PAGING'
              }
              sessionStorage.setItem('LAST_ROUTE_PARAMS', kendo.stringify(params))
              return kendo.stringify(params)
            }
            if (operation !== 'read' && options.models) {
              return {models: kendo.stringify(options.models)}
            }
          }
        },
        schema: {
          type: 'json',
          parse(response) {
            if (response.resultStatus.messageCode !== '2000') {
              kendo.alert('message: ' + response.resultStatus.messageText)
              return ''
            }
            const changeResultData = response.resultData
            let rowNumber = response.total > 1 ? response.total - ((vm.$refs.lockerGridRef.dataSource.page() - 1) * vm.$refs.lockerGridRef.dataSource.pageSize()) : response.total

            if (changeResultData === null) {
              return false
            }
            for (let i = 0; i < changeResultData.length; i++) {
              const row = changeResultData[i]
              row.rowNumber = rowNumber--
            }
            response.resultData = changeResultData
            return response
          },
          total(response) {
            return response.total
          },
          data(response) {
            if (response.resultStatus.messageCode === '2000') {
              vm.lockerInfo = response.resultData
              return response.resultData
            } else {
              kendo.alert('message: ' + response.resultStatus.messageText)
              return ''
            }
          }
        },
        error(e) {
          // console.log('error event handler', e.errors)
        }
      })
    },
    // 검색 조건 세팅
    currentPageFilterOption() {
      const vm = this
      const refs = vm.$refs

      const currentSearchDataObj = {}

      if (refs.areaRef !== undefined) {
        const area = refs.areaRef.kendoWidget().value()
        if (area !== null && area !== '') {
          currentSearchDataObj.area = area
        }
      }
      if (refs.storageTypeRef !== undefined) {
          const storageType = refs.storageTypeRef.kendoWidget().current().index()
          if (storageType !== '' && storageType !== null) {
              let resultstorageType
              if (storageType === 0) {
                  resultstorageType = ''
              } else if (storageType === 1) {
                  resultstorageType = '02'
              } else if (storageType === 2) {
                  resultstorageType = '01'
              }
              currentSearchDataObj.storageType = resultstorageType
          }
        }

      if (refs.lockerNmRef !== undefined) {
          const lockerNm = refs.lockerNmRef.kendoWidget().value().trim()
          if (lockerNm !== null && lockerNm !== '') {
              currentSearchDataObj.lockerNm = lockerNm
          }
      }

      if (refs.useYnRef !== undefined) {
        const useYn = refs.useYnRef.kendoWidget().current().index()
        if (useYn !== '' && useYn !== null) {
          let resultUseYn
          if (useYn === 0) {
            resultUseYn = ''
          } else if (useYn === 1) {
            resultUseYn = 'Y'
          } else if (useYn === 2) {
            resultUseYn = 'N'
          }
        currentSearchDataObj.useYn = resultUseYn
        }
      }
      return currentSearchDataObj
    },
    // 조건에 따른 검색
    commonOnChangeEvent() {
      const vm = this
      const gridRefs = this.$refs.lockerGridRef

      if (gridRefs !== undefined && gridRefs.kendoWidget() !== undefined) {
        if (vm.lastRouteParams.page === undefined) {
          gridRefs.kendoWidget().dataSource.page(1)
        } else {
          gridRefs.kendoWidget().dataSource.read()
          this.lastRouteParams.page = undefined
        }
      }
    },
    // 검색 조건 초기화
    cleanFilter() {
      const vm = this
      const refs = vm.$refs

      if (refs.areaRef !== undefined) {
        refs.areaRef.kendoWidget().value('')
      }
      if (refs.useYnRef !== undefined) {
        refs.useYnRef.kendoWidget().select(0)
      }
      if (refs.storageTypeRef !== undefined) {
        refs.storageTypeRef.kendoWidget().select(0)
      }
      if (refs.lockerNmRef !== undefined) {
        refs.lockerNmRef.kendoWidget().value('')
      }
      vm.getlockerList()
    },
    onETON(){
      console.log(
          "                                                                             \n" +
          "                                                                             \n" +
          "                                .&&$ .;X$&&$;..                              \n" +
          "                           :+ &$$$XX&& x.   :x$&&&&&+.                       \n" +
          "                         :.x ;&     .x +    +X$XXx+xXX&&$:                   \n" +
          "                       +$;+&x X   &&   $+X&&&X+. .:::;;+x$&x                 \n" +
          "                    :&+&&&&&& x&&&  +&&&&&&&.       .:::;++x$$               \n" +
          "                   &&:;&$XX$&&& x&&&&&&&&&&X;.  ..;+  ;;:;+;:X&&             \n" +
          "                  &&. X&&&&&&&&&&&x.::x$&&&&&&&&$x:.+X;;++;+;;+X&&           \n" +
          "                ;&X  &&&&                    ;&&&&&X;:++:+;;;;;+x$&$         \n" +
          "               &$; +&&X                          X&&&x. .;+;;;xx;;x$&        \n" +
          "              &X  &&$   .                          $&&+. ;;+;;;++;+x$&       \n" +
          "             &+;&&&   ..                            x&$; ;;:;;;;+++:;X&      \n" +
          "            &Xx&&&   ..  &&      &&                  X&;. ++;:;+++;;xX$&     \n" +
          "            &x&&$   .:  &&&  . &&&&                  :&&: ;+;+++;;+;:;x&:    \n" +
          "           &+&&&  ..::                                X&; .++;;++;;;xx;x&    \n" +
          "          &X&&&   ..::                                x&; .+;++;;+;++:+x&;   \n" +
          "         :$.&&      .:  &&&&&&&&&X             ;+xx;  ;&+ :+;;;+;+++;;++X&   \n" +
          "         &:+&& &&X  ::. &&&&&&&&&   .        :xXx++x+  &+.:+;;+x+x+++;;;+&   \n" +
          "        &$ &&+X&$X  ...  :&&&&&              +xxx++Xx  X+;;;+;;;;;;xx++xx&   \n" +
          "        &$ &&.&&$x .:::;            .......  ;xX$$$X; .+;++xxxXxx+xXxXx+X&   \n" +
          "        &&.&&;&&&. .:..::.:.             .     ;x+:   $;+x+XXxxxXXXXx+++X&   \n" +
          "        &&; && x.  ..:.:..:.                        .$;+xxXXXXXXXXX$xx+XX&   \n" +
          "        &&$ X&. .:.::+++;;;;+xxx+;;... ...:.::;:. .X&.x$XxXXxXXXXXX$XxXX&    \n" +
          "         &&& $&;  :;..   .. ..:;::.....:::;;;;:..x&& xX$$xX$$$$X$$&$xxx$&    \n" +
          "         $&&&. &&&&&&&&&&&&&&&&&&&&&&&$$$x;...;X&& ;$&&&&$XXX$$XX$$x++&&     \n" +
          "        ;    .       ..         .    ..:.XX&&&&+ X&&&$$$X$$XXXX&$&X+x&&      \n" +
          "        &x;::;:;;::;;:;;;;;:::;;;;;;;;;;:x;:x$&&&&$XXX$XxxXXXXX$XX+x$:       \n" +
          "        &;+:;:;;;:::::;;;:;:;;::;:;:;:;:;x;; .X&&$XXXX$XXxXXXXxXx+;;         \n" +
          "       $X;;;;+:;::;;:;;.:;;;;:::;::::::.++;;+:  x&&$XX&XxxXx++:;:.           \n" +
          "       &;   ...              :;::;;;;;:.X++++++;..+&&&&++::....:             \n" +
          "      .$.x&&&X$$&$+$&&&&&&&& ::::;;:::::x;;;;;+++:: :&. .:::;                \n" +
          "      &&+&    X : &$       &.XXX$$X$$$XXX+xx++++;+x;x&$                      \n" +
          "      :  &.&&Xx$$$$x&&&&&&&.            x$Xx;;;x$&&&&x$X                     \n" +
          "      :  &                &  .::.....  .  .XX$&&&.   +&&&;                   \n" +
          "     +  ;X         &   ;; &   . ...:;:;;..   &         .XX;                  \n" +
          "     $. &&&&&&&&&&&&.;;;  &              .:. ;          &$&                  \n" +
          "    .&+.&                &&x$$&$&$$&&$&x   ..&          &&&                  \n" +
          "    &X;X&&&&&&&&&&&&&&&&&&;.;;;;;+;+;.XX$&+  &&        :X:                   \n" +
          "    &;;                    ;;;;;;;;;:;xx+xX$X:&&&&; ;$&&&&                   \n" +
          "    &;+;;;;+;;;;;;;;;;;;;;;;;;;+++;;.+x++++;xx&:x&&&&&&$&&                   \n" +
          "   &X;;;;;;;;;;+;;:;;;;;;;;;;+;;;+;+:+++++x+x;x&X+.&$XX&&&                   \n" +
          "   &;::;;;+;;;;;;;;++;;;;;;+++;;;;;;:++++++;x;;X&&;&$$$&&&                   \n" +
          "   &&&$+:.                           x+++++;x;;+XX+XxX&$$&                   \n" +
          "      &&&&&&&&&&&&&&&&&&&&&&$$XXXx++.  .:;+++x++X+&Xx+X+X&                   \n" +
          "          &&&&&&XxxXXXxxXX$$$$&&&&&&&&&+  .:+++;x+&$$$&x&.                   \n" +
          "              :&&&&&&&XXxx++x+xxxXxXxX$&&&X.  :;.+&$$$&$&                    \n" +
          "                     &&&&&&&&&&&$$$XXXXxXXX&&X+. +&x$&&&&                    \n" +
          "                      &XxxxxxxxXXXXX$$$$$$$$&&&&X&&+xX&&.                    \n" +
          "                      &$XXXXXXXX$$$&&&&$$XXXX$$&&&x++xx$                     \n" +
          "                      &$XXXXXX$X$&&&&&&&&&&&$xx+;;;++X$$                     \n" +
          "                     ;&&&&&&XX$xX&&        &&$$X$&&$&&&x                     \n" +
          "                     $x++.x&&&&&&$          &&$$$$$$$$$X&                    \n" +
          "                   &&$;..:.  x&&.            &&&XXX$&&&&&                    \n" +
          "                   X.      :  &;              x&&&&&&&&$                     \n" +
          "                   X+:....  ..                  &&Xx                         \n" +
          "                    :Xx;:;+:;                    ;   .                       \n" +
          "                       xXXx                                                  \n" +
          "                                                                             "
      )
    },
  },
  data: function () {
    const kendoGridHeaderAttributes = {
      style: 'font-weight: bold; text-align : center;'
    }
    const vm = this
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      dataSourceArray: [],
      lastRouteParams: [],
      lockerDataSource: [],
      lockerInfo: [],
      lockerListColumns: [
        {
          field: 'rowNumber',
          title: 'No.',
          width: '5%',
          sortable: false
        },
        {
          field: 'lockerNm',
          title: '무인 보관함 명',
          width: '15%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
        },
        {
          field: 'facilityNm',
          title: '사업장',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'areaNm',
          title: '거점',
          width: '10%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'mappedKiosk',
          title: '연결된 키오스크',
          template(dataItem) {
            return EtnersParseUtil.convertEmptyStringToSeparator(dataItem.mappedKiosk)
          },
          width: '13%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'useYn',
          title: '활성화 여부',
          template(dataItem){
              if (dataItem.useYn == 'Y'){
                  return dataItem.useYn = "사용"
              }
              if (dataItem.useYn == 'N'){
                  return dataItem.useYn = "미사용"
              }
          },
          width: '8%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'frstRgstDt',
          title: '생성일시',
          width: '13%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
        }
      ]
    }
  }
}
</script>
